'use strict';

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.replace");

var _require = require('./url'),
    URLWithLegacySupport = _require.URLWithLegacySupport,
    format = _require.format;

module.exports = function (url) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var protocolMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultProtocol = arguments.length > 3 ? arguments[3] : undefined;
  var protocol = location.protocol ? location.protocol.replace(':', '') : 'http'; // Check protocol map

  protocol = (protocolMap[protocol] || defaultProtocol || protocol) + ':';
  var urlParsed;

  try {
    urlParsed = new URLWithLegacySupport(url);
  } catch (err) {
    urlParsed = {};
  }

  var base = Object.assign({}, location, {
    protocol: protocol || urlParsed.protocol,
    host: location.host || urlParsed.host
  });
  return new URLWithLegacySupport(url, format(base)).toString();
};